import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { RoleRestService } from 'app/admin/roles/role-rest.service';

@Component({
  selector: 'app-add-article',
  templateUrl: './add-article.component.html',
  styleUrls: ['./add-article.component.scss']
})
export class AddArticleComponent implements OnInit {
  registerForm: FormGroup
  serverErrors = [];
  fileData: File = null;
  constructor(private auth: RoleRestService, private route: Router) { }

  ngOnInit() {

    this.registerForm = new FormGroup({
      'title': new FormControl(null, [Validators.required, Validators.minLength(10)]),
      'content': new FormControl(null, [Validators.required, Validators.minLength(5)]),
      /*'image': new FormControl(null),*/
   })
  }

 /* OnFileSelected(event){
    this.fileData = <File>event.target.files[0];
    this.registerForm.get('image').setValue(this.fileData);
  }  */
  
  get Titre() { return this.registerForm.get('title'); }
  get Contenu() { return this.registerForm.get('content'); }
  /*get Image() { return this.registerForm.get('image'); } */

addPost()
  {
    this.auth.addPost(this.registerForm).subscribe(res=>{
      this.route.navigate(['/home'])
    },err=>{
      //console.log(err)
    })
  }

}
